import { render, staticRenderFns } from "./orderMgtyw.vue?vue&type=template&id=07377744&scoped=true&"
import script from "./orderMgtyw.vue?vue&type=script&lang=js&"
export * from "./orderMgtyw.vue?vue&type=script&lang=js&"
import style0 from "./orderMgtyw.vue?vue&type=style&index=0&id=07377744&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07377744",
  null
  
)

export default component.exports